import OrdersPageFilters from './OrdersPageFilters-compose';

export default OrdersPageFilters;
